import React, { forwardRef } from 'react';
import { Input, InputGroup, InputGroupText } from 'reactstrap';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import { injectIntl } from 'react-intl';
import ro from 'date-fns/locale/ro';
import enUs from 'date-fns/locale/en-US';
import { ROMANIAN_LOCALE } from '../../languages';

const DateInputWithIcon = forwardRef( (props, ref) => {
  return (
    <div>
      <InputGroup>
        <Input className="custom-date-input-with-icon" onClick={props.onClick}
               ref={ref} placeholder={props.value} readOnly={true}/>
        <InputGroupText className="icon-custom-date" onClick={props.onClick} >
          <FontAwesomeIcon className="mr-2" icon={faCalendarAlt} size="lg"/>
        </InputGroupText>
      </InputGroup>
    </div>
  );
} );

const DatePickerWithIconComponent = (props) => {
  const { name, classNames, placeHolderTextId, selectedDate, minDate, dateFormat, yearDropdownItemNumber, disableWeekendDay, onChange } = props;

  const isWeekday = (date) => {
    if (disableWeekendDay) {
      const day = date.getDay();
      return day !== 0 && day !== 6;
    }

    return true;
  };

  return (
    <DatePicker
      name={name}
      className={classNames}
      placeholderText={props.intl.formatMessage( { id: placeHolderTextId } )}
      selected={selectedDate}
      minDate={minDate}
      locale={props.lang === ROMANIAN_LOCALE.lang ? ro : enUs}
      showDisabledMonthNavigation
      dateFormat={dateFormat}
      filterDate={isWeekday}
      yearDropdownItemNumber={yearDropdownItemNumber}
      scrollableYearDropdown
      showYearDropdown
      onChange={
        date => {
          onChange(date);
        }
      }
      customInput={<DateInputWithIcon/>}
    />
  )
}

const mapStateToProps = state => ({
  lang: state.locale.lang,
});

const DatePickerWithIcon = injectIntl(connect(mapStateToProps)(DatePickerWithIconComponent));

export { DatePickerWithIcon, DatePickerWithIconComponent }
